import { bool, number, shape } from 'prop-types'

export const redPointsType = shape({
  multiplierRP: number,
  redPoints: number,
  redPointsIsActive: bool,
  redPointsMultiplierIsValid: bool,
  prescriptionMedicine: bool,
})
